module.exports = __webpack_public_path__ + "img/mon_256.232d62fc.png";